import { jwtDecode } from "jwt-decode";

function Reducer(state, action) {
  if (Array.isArray(action)) {
    action.forEach((x) => {
      state = Reducer(state, x);
    });
    return state;
  } else {

    switch (action.type) {
      case "SET_READY":
        return { ...state, ready: action.payload };
      case "SET_PROFILE":
        return { ...state, profile: action.payload };
      case "SET_LOGGED":
        let isLogged = false;
        let jwt = null;
        let profile = null;
        let jwtDecoded = null;

        // Aceita tanto { token } (vindo do backend) quanto null (logout)
        const token = action.payload?.token ?? action.payload?.accessToken ?? null;

        if (token) {
          jwtDecoded = jwtDecode(token);

          const now = Date.now() / 1000;
          const expirado = jwtDecoded.exp && jwtDecoded.exp < now;

          if (!expirado) {
            profile = {
              id: jwtDecoded["nameid"],
              name: jwtDecoded["unique_name"],
              email: jwtDecoded["email"],
              primeiroNome: jwtDecoded["primeiroNome"],
              ultimoNome: jwtDecoded["ultimoNome"],
              podeCriarEventos: jwtDecoded["podeCriarEventos"] === "true",
              podeCriarLayouts: jwtDecoded["podeCriarLayouts"] === "true",
            };

            isLogged = true;
            jwt = token;
            localStorage.setItem("jwt", jwt);
          } else {
            localStorage.removeItem("jwt");
          }
        } else {
          localStorage.removeItem("jwt");
        }

        return {
          ...state,
          jwtDecoded: jwtDecoded,
          isLogged: isLogged,
          jwt: jwt,
          profile: profile,
        };
      case "SET_LOADING":
        return { ...state, loading: action.payload };
      default:
        return state;
    }
  }
}

export default Reducer;
